<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_4"></a>DEDICATION</p>
<p class="ded">This book is dedicated to the Maroun Clan and particularly to the younger generation who did not have the pleasure and privilege of knowing their ancestors, Giddy and Siti (Grandad and Granny) Maroun.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?02adba6c